module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "chaptertitle"
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('b', [_c('i', [_vm._v("No one, other than my wife")]), _vm._v(",")]), _vm._v(" has had as much belief in me as Jerry Lee. Jerry and his wife, Donna, are incredibly giving people who helped me believe that we could create a company that built running shoes specifically for natural running form. We hoped to reduce injury rates and create a more enjoyable running experience for runners all over the world. With a focus on giving back to the community—and to the world as it grows—Newton is a charitable company thanks to the Jerry and Donna Lee Family Foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The athletes and coaches at the "), _c('a', {
    attrs: {
      "href": "http://www.Multisports.com",
      "target": "_blank"
    }
  }, [_vm._v("Multisports.com")]), _vm._v(" training camps also believed in me; starting in 1993, they encouraged me to coach running biomechanics, injury prevention, and running form. My deepest thanks go especially to Paula Newby-Fraser, Paul Huddle, Heather Fuhr, Roch Frey, and Jimmy Riccitello for using Active Imprints custom orthotics to boost their own athletic performance and for allowing me to coach thousands of runners through their triathlon camps. They also were part of our original testing group for Newton running shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A big thank-you goes to Brian Metzler for his invaluable assistance in crafting the language of this book and for guiding me down the technical trail of writing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, to all the running coaches around the world with open minds who have worked hard for many years with little credit to help runners adjust their form to a more natural running style—thank you, and keep up the good work!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f8c5382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 81
// module chunks = 0